import { render, staticRenderFns } from "./document-page.vue?vue&type=template&id=880cd8ce&scoped=true&"
import script from "./document-page.vue?vue&type=script&lang=js&"
export * from "./document-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880cd8ce",
  null
  
)

export default component.exports